import { useEffect } from "react";
import { Carousel } from "bootstrap"; import React from "react";

export const Header = () => {

  useEffect(() => {
    const element = document.getElementById("carouselHeader");

    if (element) {
      new Carousel(element, {
        interval: 3000,
        ride: "carousel",
        pause: false,
        wrap: true,
        touch: true,
      });
    }
  }, []);

  return (
    <header id="header">
      <div
        id="carouselHeader"
        className="carousel slide carousel-fade"
      >
        {/* Indicators */}
        <div className="carousel-indicators">
          <button
            type="button"
            data-bs-target="#carouselHeader"
            data-bs-slide-to="0"
            className="active"
          />
          <button
            type="button"
            data-bs-target="#carouselHeader"
            data-bs-slide-to="1"
          />
        </div>

        {/* Slides */}
        <div className="carousel-inner">

          {/* SLIDE 1 */}
          <div className="carousel-item active">
            <img
              src="img/home2-2.jpg"
              className="d-block w-100"
              alt="Dr Ricardo Barbuti"
            />

            <div className="carousel-overlay d-flex align-items-end">
              <div className="container pb-4">
                <div className="row">
                  <div className="col-md-8 offset-md-2 intro-text text-center">
                    <h1>DR RICARDO BARBUTI</h1>
                    <p>Especialista em Gastroenterologia</p>
                    <a href="/ricardo-barbuti" className="btn btn-custom btn-lg">
                      Saiba Mais
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* SLIDE 2 */}
          <div className="carousel-item">
            <img
              src="img/helCarr1.jpeg"
              className="d-block w-100 slide-dra-helena"
              alt="Dra Helena Atroch"
            />

            <div className="carousel-overlay d-flex align-items-end">
              <div className="container pb-4">
                <div className="row">
                  <div className="col-md-8 offset-md-2 intro-text text-center">
                    <h1>DRA HELENA ATROCH</h1>
                    <p>Especialista em Endocrinologia</p>
                    <a href="/helena-atroch" className="btn btn-custom btn-lg">
                      Saiba Mais
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* SLIDE 3 */}
          {/* <div className="carousel-item">
            <img
              src="img/ricardo.jpg"
              className="d-block w-100"
              alt="Dr Ricardo Barbuti"
            />

            <div className="carousel-overlay d-flex align-items-end">
              <div className="container pb-4">
                <div className="row">
                  <div className="col-md-8 offset-md-2 intro-text text-center">
                    <h1>DR LUCA BARBUTI</h1>
                    <p>Especialista em Gastroenterologia</p>
                    <a href="/luca-barbuti" className="btn btn-custom btn-lg">
                      Saiba Mais
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div> */}

        </div>

        {/* Controls */}
        <button
          className="carousel-control-prev"
          type="button"
          data-bs-target="#carouselHeader"
          data-bs-slide="prev"
        >
          <span className="carousel-control-prev-icon" />
        </button>

        <button
          className="carousel-control-next"
          type="button"
          data-bs-target="#carouselHeader"
          data-bs-slide="next"
        >
          <span className="carousel-control-next-icon" />
        </button>
      </div>
    </header>
  );
};